<template>
  <div id="index-exam-list">
    <!-- 学生端考试列表 -->
    <diy_table
      :loading="loading"
      :searchData="searchData"
      :buttonList="buttonList"
      :tableMenu="tableMenu"
      :tableData="tableData"
      :tableButton="tableButton"
      :pageData="pageData"
      @initTable="initTable"
      @handleClick="handleClick"
    ></diy_table>
  </div>
</template>

<script>
import * as examData from "./js/exam.js";
export default {
  data() {
    return {
      loading: false,
      userData: {},
      searchData: examData.getSearchData("exam"),
      buttonList: examData.getTopButArray("exam"),
      tableMenu: examData.getQuestionTableMenu(),
      tableData: [],
      tableButton: examData.getTableBUttonList("exam"),
      pageData: {
        currentPage: 1, // 当前页数
        pageSize: 10, // 每页条数
        total: 0, // 总条目数
      },

      tempExam: {},
    };
  },
  methods: {
    /**
     * 初始化表格数据
     */
    async initTable(data) {
      this.loading = true;
      try {
        let requestData = {
          currentPage: data.pageData.currentPage,
          pageSize: data.pageData.pageSize,
        };
        requestData = this.$baseData.array2json(data.searchData, requestData);
        if (requestData.time == null || requestData.time.length == 0) {
          requestData.time = ["", ""];
        }
        requestData.status =
          requestData.status == "0" ? "" : requestData.status;
        let resultData = await this.$request({
          url: "/studentExam/getAllTestListByUser",
          method: "post",
          data: requestData,
        });
        this.tableData = resultData.tableData;
        this.pageData.total = resultData.total;
        this.loading = false;
      } catch (error) {
        this.$message.error(error.message);
        this.loading = false;
      }
    },
    /**
     * 表格中的操作事件
     */
    async handleClick(data) {
      try {
        this.tempExam = JSON.parse(JSON.stringify(data.item));
        switch (data.active) {
          case "show_exam":
            this.$router.push({
              path: "/exam/prepare",
              query: {
                id: this.tempExam.id,
              },
            });
            break;

          default:
            break;
        }
      } catch (error) {
        this.$message.error(error.message);
      }
    },
  },
  async mounted() {
    this.userData = JSON.parse(sessionStorage.getItem("userData"));
    await this.initTable({
      pageData: this.pageData,
      searchData: this.searchData,
    });
  },
};
</script>

<style lang="less" scoped>
#index-exam-list {
  width: 100%;
  height: 100%;
}
</style>